// Custom components
import React, { useEffect, useState } from 'react';
import { IoSearchOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import {
  salesExcel,
  salesReports,
  stockReports,
} from '../../../redux/actions/Report.action';
import { Button, Dropdown } from 'react-bootstrap';
import * as XLSX from 'xlsx';
import { IoIosArrowDown } from 'react-icons/io';
import ReactPaginate from 'react-paginate';

export default function GstProductReport() {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.report);
  console.log('reportData', reportData);

  const [formData, setFormData] = useState({
    date: '',
    startDate: '',
    endDate: '',
    search: '',
  });
  const [selectedGST, setSelectedGST] = useState('');
  const [uniqueGSTValues, setUniqueGSTValues] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === 'startDate' || name === 'endDate' ? { date: '' } : {}),
      ...(name === 'date' ? { startDate: '', endDate: '' } : {}),
    }));
  };

  useEffect(() => {
    let payload = {};
    if (formData.date) {
      payload.date = formData.date;
    } else {
      payload.date = '';
    }

    if (formData.startDate || formData.endDate) {
      payload.startDate = formData.startDate;
      payload.endDate = formData.endDate;
    } else {
      payload.startDate = '';
      payload.endDate = '';
    }
    if (formData.search) {
      payload.search = formData.search;
    } else {
      payload.search = '';
    }
    if (formData) {
      dispatch(salesExcel(payload));
    }
  }, [formData]);

  useEffect(() => {
    const gstValues = new Set();
    reportData?.salesExcel?.data?.data?.forEach((res) => {
      res?.productList?.forEach((product) => {
        if (product.gst) gstValues.add(product.gst);
      });
    });
    setUniqueGSTValues(Array.from(gstValues));
  }, [reportData]);

  const filteredData = reportData?.salesExcel?.data?.data
    ?.map((res) => ({
      ...res,
      productList: res.productList.filter((product) => {
        const matchesGST = selectedGST ? product.gst === selectedGST : true;
        return matchesGST;
      }),
    }))
  // .filter((res) => {
  //   const matchesSearch = (res.patientName || '')
  //     .toLowerCase()
  //     .includes(formData.search.toLowerCase());
  //   return matchesSearch && res.productList.length > 0;
  // });
  useEffect(() => {
    setCurrentPage(0);
  }, [formData.search]);
  // Pagination Calculation
  const offset = currentPage * itemsPerPage;
  const currentData = filteredData?.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData?.length / itemsPerPage) || 1;

  // Handle Page Change
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };
  const handleDownload = () => {
    const excelData = [];

    filteredData.forEach((item) => {
      if (item?.productList?.length > 0) {
        item?.productList?.forEach((product) => {
          excelData.push({
            'Invoice Date': new Date(item.invoiceDate).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            }),
            'Patient Name': item.patientName,
            'Invoice No': item.invoiceNo,
            'Product Name': product.productName,
            'HSN Code': product.hsnCode,
            Pack: product.pack,
            MRP: product.mrp,
            'Batch No.': product.batchNo,
            'Exp. Date': new Date(product.expDate).toLocaleDateString('en-GB', {
              month: '2-digit',
              year: 'numeric',
            }),
            Rate: product.rate,
            Qty: product.qty,
            'Gross Amount': product.totalAmount,
            'GST (%)': product.gst,
            Amount: product.amount,
          });
        });
        excelData.push({});
      }
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'GST Product Report');
    XLSX.writeFile(workbook, 'GST_Product_Report.xlsx');
  };

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex items-center gap-3">
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Date</label>
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div className="w-[200px]">
            <label className="text-sm block mb-1">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleFormData}
              className="w-75 outline-none !border-b"
            />
          </div>
          <div>
            <label className="text-sm block mb-1">GST</label>
            <Dropdown className="w-[150px]">
              <Dropdown.Toggle
                id="dropdown-basic"
                className="text-start !text-gray-500 !flex items-center justify-between !text-sm shadow-none px-2 py-1 w-full !border-gray-200 bg-transparent"
              >
                {selectedGST || 'Select GST'} <IoIosArrowDown />
              </Dropdown.Toggle>
              <Dropdown.Menu className="w-full !text-sm">
                <Dropdown.Item onClick={() => setSelectedGST('')}>
                  All
                </Dropdown.Item>
                {uniqueGSTValues.map((gst) => (
                  <Dropdown.Item key={gst} onClick={() => setSelectedGST(gst)}>
                    {gst}%
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button
              onClick={handleDownload}
              className="px-4 !bg-theme-dark border-0 text-white"
            >
              Download
            </Button>
          </div>
        </div>
        <div className="text-end mt-4">
          Total Records:{' '}
          <span className="text-success border-b border-success">
            {
              filteredData?.filter((sales) => sales?.productList?.length > 0).length
            }
          </span>
        </div>

      </div>

      <div className="mt-[50px] mb-4">
        <div className="row">
          {/* <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Patient Name
          </div> */}
          <div className="col-2 uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Product Name
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            HSN Code
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Pack
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            MRP
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Batch No.
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Exp. Date
          </div>
          {/* <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Discount
          </div> */}
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Rate
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Qty
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Gross Amount
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            GST (%)
          </div>
          <div className="col uppercase font-bold text-sm text-[#4A5568] px-[24px] py-[12px]">
            Amount
          </div>
        </div>
        {filteredData?.length > 0 && filteredData?.filter((sales) => sales?.productList?.length > 0).length > 0 ? (
          filteredData?.map((sales) => {
            if (sales?.productList?.length > 0) {
              return (
                <>
                  <div className="row bg-[rgba(0,0,0,0.08)]">
                    <div className="col-2">{new Date(sales.invoiceDate).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: '2-digit',
                      year: 'numeric'
                    })}</div>

                    <div className="col-2">{sales.patientName}</div>
                    <div className='col-3'>Invoice No. {sales.invoiceNo}</div>
                    <div className="col-2">
                      Extra Discount :{" "}
                      {sales?.discountAmount && parseFloat(sales?.discountAmount) > 0
                        ? sales?.discountAmount + " (rs)"
                        : sales?.cDiscount && parseFloat(sales?.cDiscount) > 0
                          ? ((parseFloat(sales?.billAmount) * parseFloat(sales?.cDiscount)) / 100).toFixed(2) + " (rs)"
                          : "0"}
                    </div>
                    <div className='col text-end'>Total : {sales.billAmount}</div>
                  </div>
                  <div className='bg-white mb-3 shadow-sm'>
                    {sales?.productList?.map((res) => {
                      return (
                        <div className="row">
                          {/* <div className="col px-[24px] py-[12px] uppercase"></div> */}
                          <div className="col-2 px-[24px] py-[12px] uppercase">
                            {res.productName}
                          </div>
                          <div className="col px-[24px] py-[12px] uppercase">
                            {res.hsnCode}
                          </div>
                          <div className="col px-[24px] py-[12px] uppercase">
                            {res.pack}
                          </div>
                          <div className="col px-[24px] py-[12px] uppercase">
                            {res.mrp}
                          </div>
                          <div className="col px-[24px] py-[12px] uppercase">
                            {res.batchNo}
                          </div>
                          <div className="col px-[24px] py-[12px]">
                            {new Date(res.expDate).toLocaleDateString('en-GB', {
                              month: '2-digit',
                              year: 'numeric',
                            })}
                          </div>
                          {/* <div className="col px-[24px] py-[12px]">{res.discount} {res.discount && '%'}</div> */}
                          <div className="col px-[24px] py-[12px]">{res.rate}</div>
                          <div className="col px-[24px] py-[12px]">{res.qty}</div>
                          <div className="col px-[24px] py-[12px]">
                            {res.totalAmount}
                          </div>
                          <div className="col px-[24px] py-[12px]">{res.gst}</div>
                          <div className="col px-[24px] py-[12px]">
                            {res.amount}
                          </div>
                        </div>
                      );
                    })}
                    {/* <div className='row border-t'>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col-2 px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'>Ex: {sales.discountAmount || sales.cDiscount} {sales.discountAmount ? '(rs)' : '%'}</div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                      <div className='col px-[24px] py-[12px]'></div>
                    </div> */}
                  </div>
                </>
              );
            } else {
              return (
                <></>
              )
            }
          })
        ) : (
          <div className="px-[24px] py-[12px] bg-[rgba(0,0,0,0.06)]">
            No any data
          </div>
        )}
      </div>
      {/* {currentData?.length > 0 && <>
      
        <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageChange}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
        forcePage={currentPage}
      />
      </>} */}
    </>
  );
}
